export enum AddressState {
  AGUASCALIENTES,
  BAJA_CALIFORNIA,
  BAJA_CALIFORNIA_SUR,
  CAMPECHE,
  COAHUILA,
  COLIMA,
  CHIAPAS,
  CHIHUAHUA,
  DURANGO,
  DISTRITO_FEDERAL,
  GUANAJUATO,
  GUERRERO,
  HIDALGO,
  JALISCO,
  MEXICO,
  MICHOACAN,
  MORELOS,
  NAYARIT,
  NUEVO_LEON,
  OAXACA,
  PUEBLA,
  QUERETARO,
  QUINTANA_ROO,
  SAN_LUIS_POTOSI,
  SINALOA,
  SONORA,
  TABASCO,
  TAMAULIPAS,
  TLAXCALA,
  VERACRUZ,
  YUCATAN,
  ZACATECAS
}

export const stateMap: { [key in AddressState]: string } = {
    [AddressState.AGUASCALIENTES]: 'AGUASCALIENTES',
    [AddressState.BAJA_CALIFORNIA]: 'BAJA CALIFORNIA',
    [AddressState.BAJA_CALIFORNIA_SUR]: 'BAJA CALIFORNIA SUR',
    [AddressState.CAMPECHE]: 'CAMPECHE',
    [AddressState.COAHUILA]: 'COAHUILA',
    [AddressState.COLIMA]: 'COLIMA',
    [AddressState.CHIAPAS]: 'CHIAPAS',
    [AddressState.CHIHUAHUA]: 'CHIHUAHUA',
    [AddressState.DURANGO]: 'DURANGO',
    [AddressState.DISTRITO_FEDERAL]: 'DISTRITO FEDERAL',
    [AddressState.GUANAJUATO]: 'GUANAJUATO',
    [AddressState.GUERRERO]: 'GUERRERO',
    [AddressState.HIDALGO]: 'HIDALGO',
    [AddressState.JALISCO]: 'JALISCO',
    [AddressState.MEXICO]: 'MEXICO',
    [AddressState.MICHOACAN]: 'MICHOACAN',
    [AddressState.MORELOS]: 'MORELOS',
    [AddressState.NAYARIT]: 'NAYARIT',
    [AddressState.NUEVO_LEON]: 'NUEVO LEON',
    [AddressState.OAXACA]: 'OAXACA',
    [AddressState.PUEBLA]: 'PUEBLA',
    [AddressState.QUERETARO]: 'QUERETARO',
    [AddressState.QUINTANA_ROO]: 'QUINTANA ROO',
    [AddressState.SAN_LUIS_POTOSI]: 'SAN LUIS POTOSI',
    [AddressState.SINALOA]: 'SINALOA',
    [AddressState.SONORA]: 'SONORA',
    [AddressState.TABASCO]: 'TABASCO',
    [AddressState.TAMAULIPAS]: 'TAMAULIPAS',
    [AddressState.TLAXCALA]: 'TLAXCALA',
    [AddressState.VERACRUZ]: 'VERACRUZ',
    [AddressState.YUCATAN]: 'YUCATAN',
    [AddressState.ZACATECAS]: 'ZACATECAS',
}

export const stateToString = (val: AddressState) => {
  return stateMap[val];
}

